import { useLocation } from 'react-router-dom';

const pageMap = [
  {
    path: /^\/trial-portfolio$/,
    moduleName: 'Trial Portfolio',
    pageName: 'Overview',
  },
  {
    path: /^\/trial-portfolio\/trial-delivery-goals$/,
    moduleName: 'Trial Portfolio',
    pageName: 'Delivery Goals',
  },
  {
    path: /^\/trial-portfolio\/cycle-time$/,
    moduleName: 'Trial Portfolio',
    pageName: 'Cycle Time',
  },
  {
    path: /^\/trial-portfolio\/protocol-amendments$/,
    moduleName: 'Trial Portfolio',
    pageName: 'Protocol Amendments',
  },
  {
    path: /^\/trial-portfolio\/trial-performance$/,
    moduleName: 'Trial Portfolio',
    pageName: 'Trial Performance',
  },
  {
    path: /^\/trial-portfolio\/portfolio-diversity$/,
    moduleName: 'Trial Portfolio',
    pageName: 'Diversity',
  },

  {
    path: /^\/trial-management\/overview$/,
    moduleName: 'Trial Management',
    pageName: 'Overview',
  },
  {
    path: /^\/trial-management\/details\/[^/]+$/,
    moduleName: 'Trial Management',
    pageName: 'Details',
  },

  {
    path: /^\/country-management\/overview$/,
    moduleName: 'Country Management',
    pageName: 'Overview',
  },
  {
    path: /^\/country-management\/details\/[^/]+$/,
    moduleName: 'Country Management',
    pageName: 'Details',
  },

  {
    path: /^\/site-health$/,
    moduleName: 'Site Management',
    pageName: 'Overview',
  },
  {
    path: /^\/site-health\/site\/[^/]+$/,
    moduleName: 'Site Management',
    pageName: 'Site Detail',
  },
  {
    path: /^\/site-health\/site\/[^/]+\/trial\/[^/]+$/,
    moduleName: 'Site Management',
    pageName: 'Study-Site Detail',
  },
];

const fallbackInfo = (path) => {
  const parts = path.split('/').filter(Boolean);
  const moduleName =
    parts[0]
      ?.replace(/-/g, ' ')
      .replace(/\b\w/g, (part) => part.toUpperCase()) || 'Unknown';
  const pageName =
    parts
      .slice(1)
      .map((part) =>
        part.replace(/-/g, ' ').replace(/\b\w/g, (prt) => prt.toUpperCase()),
      )
      .join(' - ') || 'Unknown';

  return { moduleName, pageName };
};

const usePageInfo = () => {
  const { pathname } = useLocation();

  const match = pageMap.find(({ path }) => path.test(pathname));
  if (match) {
    const { moduleName, pageName } = match;
    return { moduleName, pageName };
  }

  return fallbackInfo(pathname);
};

export default usePageInfo;
